import { requestApiSaga } from '@client/common/redux/api/sagas';
import { reportError } from '@client/common/redux/errors/actions';
import { parseError } from '@client/common/utils/api/error';
import { Restock } from '@client/product/api/Restock';
import {
  restockSubscribe,
  restockSubscribeFulfilled,
  restockSubscribeRejected,
} from '@client/product/redux/restockSubscribe/redux';
import { PRODUCT_MESSAGES, showProductToast } from '@client/product/utils/product';
import { AxiosResponse } from 'axios';
import { all, AllEffect, call, CallEffect, ForkEffect, put, PutEffect, takeEvery } from 'redux-saga/effects';
import emitter, { EVENT } from 'b2b-apps/core/common/utils/eventEmitter';

function* restockSubscribeSaga(action: ReturnType<typeof restockSubscribe>): Generator<
  CallEffect | PutEffect | Generator,
  void,
  boolean & AxiosResponse<any>
> {
  const { email, sku } = action.payload;

  try {
    const response = yield call(
      requestApiSaga,
      Restock.subscribe(email, sku),
    );

    yield put(restockSubscribeFulfilled(response.data));
    emitter.dispatch(EVENT.restockSubscribeFulfilled);
    showProductToast(PRODUCT_MESSAGES.restockSubscribeSuccess);
  } catch (error) {
    yield put(reportError({ message: action.type, error, additionalData: action.payload }));
    yield put(restockSubscribeRejected({ error: parseError(error) }));
    emitter.dispatch(EVENT.restockSubscribeRejected);
  }
}

export function* restockSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeEvery(restockSubscribe.type, restockSubscribeSaga),
  ]);
}
